module.exports = __webpack_public_path__ + "img/chrome.36729db6.png";